import React from 'react';

import BasePane from '@totem/components/BasePane';
import PendingContainer from '@totem/components/internalOnly/netSuitePending/PendingContainer';
import PendingTable from '@totem/components/internalOnly/netSuitePending/PendingTable';
import CardBody from '@totem/components/ui_components/cards/CardBody';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const PendingPage = () => {
  return (
    <ContentLayout>
      <BasePane>
        <PrimaryContentPane>
          <CardBody>
            <PendingContainer>
              <PendingTable />
            </PendingContainer>
          </CardBody>
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default PendingPage;
